import { createAction, props } from '@ngrx/store';
import { TError } from '@amwager/util-ts';



/**
 * State
 */
export const initAuthState = createAction(
  '[Auth] Init State',
  props<{
    sourceInitiator: string
  }>()
);
export const clearAuthState = createAction(
  '[Auth] Clear State',
  props<{
    sourceInitiator: string
  }>()
);

export const loadAuthStateSuccess = createAction(
  '[Auth] Load Auth State Success'
);
export const loadAuthStateFailure = createAction(
  '[Auth] Load Auth State Failure',
  props<{ error: TError }>()
);


/**
 * GET Request
 */
export const renewPasswordAPI = createAction(
  '[Auth_API] Renew Password',
  props<{
    email: string,
  }>()
);

export const registerAPI = createAction(
  '[Auth_API] Registering account',
  props<{
    username: string,
    password: string,
    tmsId: string,
    talon: string,
    fingerprint: string
   }>()
);

export const completeRegistrationAPI = createAction(
  '[Auth_API] Complete Registering account',
  props<{
    firstName: string,
    lastName: string,
    phoneNumber: string,
    dateOfBirth: string,
    streetAddress: string,
    city: string,
    state: string,
    zipCode: string,
    ssn: string,
    tmsId: string | undefined,
    talon: string
  }>()
);

export const uploadDocumentsAPI = createAction(
  '[Auth_API] Uploading documents',
  props<{
    customerId: string | undefined,
    idDocuments: string,
    billDocuments: string
  }>()
);

export const jurisdictionsAPI = createAction(
  '[Auth_API] Jurisdictions',
  props<{
    country: string
  }>()
);

// ReplaceIdentifier: string,
// NewPassword: string
export const updatePasswordAPI = createAction(
  '[Auth_API] Updating password',
  props<{
    newPassword: string,
    replaceIdentifier: string,
   }>()
);

export const loggingGuestAPI = createAction(
  '[Auth_API] Logging Guest account'
);

export const loggingInAPI = createAction(
  '[Auth_API] Logging In account',
  props<{
    username: string,
    password: string,
    tmsId: string,
    from: string | undefined,
    talon: string,
   }>()
);

export const loggingOutAPI = createAction(
  '[Auth_API] Logging Out account',
  props<{ from?: string }>()
);


/**
 * GET Response SUCCESS
 */
export const renewPasswordAPISuccess = createAction(
  '[Auth_API] Renew Password Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const registerAPISuccess = createAction(
  '[Auth_API] Successfully register account',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const completeRegistrationAPISuccess = createAction(
  '[Auth_API] Successfully complete registration account',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const uploadDocumentsAPISuccess = createAction(
  '[Auth_API] Successfully upload documents',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const jurisdictionsAPISuccess = createAction(
  '[Auth_API] Successfully fetch jurisdictions',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    successResponse: any
  }>()
);

export const updatePasswordAPISuccess = createAction(
  '[Auth_API] Successfully update password',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const loginAPISuccess = createAction(
  '[Auth_API] Successfully login account',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    successResponse: any,
    username?: string
  }>()
);

export const logoutAPISuccess = createAction(
  '[Auth_API] Successfully logout account',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);


/**
 * GET Response ERROR
 */
export const renewPasswordAPIFailed = createAction(
  '[Auth_API] Renew Password Failed',
  props<{ errorResponse: TError }>()
);

export const registerAPIFailed = createAction(
  '[Auth_API] Failed to register account',
  props<{ errorResponse: TError }>()
);

export const completeRegistrationAPIFailed = createAction(
  '[Auth_API] Failed to complete registration account',
  props<{ errorResponse: TError }>()
);

export const uploadDocumentsAPIFailed = createAction(
  '[Auth_API] Failed to upload documents',
  props<{ errorResponse: TError }>()
);

export const jurisdictionsAPIFailed = createAction(
  '[Auth_API] Failed to fetch jurisdictions',
  props<{ errorResponse: TError }>()
);

export const updatePasswordAPIFailed = createAction(
  '[Auth_API] Failed to update password',
  props<{ errorResponse: TError }>()
);

export const loginAPIFailed = createAction(
  '[Auth_API] Failed to login account',
  props<{ errorResponse: TError }>()
);

export const logoutAPIFailed = createAction(
  '[Auth_API] Failed to logout account',
  props<{ errorResponse: TError }>()
);


/**
 * Properties
 */
export const setIsAuthenticated = createAction(
  '[Auth] Set if user is authenticated',
  props<{ isAuthenticated: boolean }>()
);

export const setIsRememberMe = createAction(
  '[Auth] Set if to remember an account',
  props<{ isRememberMe: boolean }>()
);

export const setUserFullName = createAction(
  '[Auth] Set user fullname',
  props<{ isFullName: string }>()
);

export const setIdFile = createAction(
  '[Auth] Set id documents',
  props<{ idFile: any }>()
);

export const setBillFile = createAction(
  '[Auth] Set bill documents',
  props<{ billFile: any }>()
);

export const setCountryStates = createAction(
  '[Auth] Set country states',
  props<{ subdivisions: any }>()
);

export const setError = createAction(
  '[Auth] Set an error',
  props<{ error: TError }>()
);
